import FieldsCollection from "../../../fields3/collection/base/fields-collection";
import FieldConfig from "../../../fields3/proto/field-config";
import {FieldType} from "../../../fields3/field-type";
import FieldString from "../../../fields3/generic/string/string";
import FieldCopyContent from "../../../fields3/generic/copy-content/copy-content";
import WebhookSecretCopyButton from "./secret-copy-button";

const baseConfig: FieldConfig[] = [
    {
        fieldId     : 'name',
        type        : FieldType.STRING,
        label       : 'Name',
        placeholder : 'Webhook name',
    },
    {
        fieldId     : 'endpointUrl',
        type        : FieldType.URL,
        label       : 'Endpoint URL',
        placeholder : 'https://example.com/hook',
    },
    {
        // COPY_CONTENT is FieldString plus a Copy button rendered *inside* the
        // input - the client owns the secret, so the field stays editable and
        // the button is the only decoration it needs.
        fieldId     : 'secret',
        type        : FieldType.COPY_CONTENT,
        label       : 'Secret',
        placeholder : 'Webhook secret',
    },
    {
        fieldId     : 'status',
        type        : FieldType.STRING,
        label       : 'Status',
    },
    {
        fieldId     : 'errorCounter',
        type        : FieldType.NUMBER,
        label       : 'Errors',
    },
    {
        fieldId     : 'momentCreated',
        type        : FieldType.MOMENT,
        label       : 'Created',
    },
]

export default class WebhookFields extends FieldsCollection {

    get name(): FieldString         { return this.get('name') as FieldString }
    get endpointUrl(): FieldString  { return this.get('endpointUrl') as FieldString }

    get secret(): FieldCopyContent  { return this.get('secret') as FieldCopyContent }

    constructor() {
        super(baseConfig)

        // COPY_CONTENT ships a copy button that carries `hover-bg`, which shows
        // its background at rest rather than on hover - deliberate on the
        // read-only fields it was built for, wrong on an editable one.
        _.assign(this.secret.components, {ButtonComponent: WebhookSecretCopyButton})
    }
}
